var _excluded = ["children"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useEffect, useContext } from 'react';
import { context, getDemoUrl } from 'dumi/theme';
import Layout from 'dumi-theme-default/es/layout';
import Device from '../components/Device';
import { ACTIVE_MSG_TYPE } from '../builtins/Previewer';
import '../style/layout.less';

var MobileLayout = function MobileLayout(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(context),
      _useContext$config = _useContext.config,
      mode = _useContext$config.mode,
      exportStatic = _useContext$config.exportStatic,
      demos = _useContext.demos,
      meta = _useContext.meta;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      demo = _useState2[0],
      setDemo = _useState2[1];

  var hasMobilePreviewer = meta.hasPreviewer && meta.mobile !== false;
  useEffect(function () {
    var handler = function handler(ev) {
      if (ev.data.type === ACTIVE_MSG_TYPE) {
        var data = JSON.parse(ev.data.value); // get auto-generated demo url if there is no custom url

        if (!data.demoUrl) {
          data.demoUrl = getDemoUrl(data.identifier, exportStatic && exportStatic.htmlSuffix);
        }

        setDemo(data);
      }
    };

    window.addEventListener('message', handler);
    return function () {
      return window.removeEventListener('message', handler);
    };
  }, []); // clear demoId when route changed

  useEffect(function () {
    setDemo(null);
  }, [props.location.pathname]); // render toc to side menu by default

  if (hasMobilePreviewer && meta.toc !== false && meta.toc === undefined) {
    meta.toc = 'menu';
  }

  return /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
    className: "__dumi-default-mobile-content"
  }, /*#__PURE__*/React.createElement("article", null, children), hasMobilePreviewer && (demo === null || demo === void 0 ? void 0 : demo.simulator) !== false &&
  /*#__PURE__*/
  // render via builtin device simulator
  React.createElement(Device, {
    className: "__dumi-default-mobile-content-device",
    url: demo === null || demo === void 0 ? void 0 : demo.demoUrl
  }), (demo === null || demo === void 0 ? void 0 : demo.simulator) === false &&
  /*#__PURE__*/
  // render demo directly (for custom compiletime)
  React.createElement("div", {
    className: "__dumi-default-device",
    "data-mode": mode
  }, /*#__PURE__*/React.createElement(demos[demo.identifier].component))));
};

export default MobileLayout;